import React, { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { useTealium } from "@hubcapp/context";

export const PageViewProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const history = useHistory();
  const { trackPageView } = useTealium();

  useEffect(() => {
    const pathNameListener = history.listen(location => {
      trackPageView(location.pathname);
    });

    return () => pathNameListener();
  }, []);

  return <>{children}</>;
};

export default PageViewProvider;
